const zeroPadded = (number: number) => (number > 9 ? number : "0" + number)

export function formattedDuration(duration: number) {
  const minutes = Math.floor(duration / 60)
  const seconds = Math.floor(duration % 60)

  return zeroPadded(minutes) + ":" + zeroPadded(seconds)
}

export function formattedWeekLabel(weekOffset: number): string {
  if (weekOffset === 0) return "This week"
  if (weekOffset === -1) return "Last week"

  const start = new Date()
  start.setDate(start.getDate() - start.getDay() + 1 + weekOffset * 7)
  const end = new Date(start)
  end.setDate(start.getDate() + 6)

  const fmt = (d: Date) =>
    d.toLocaleDateString("en", { month: "short", day: "numeric" })
  return `${fmt(start)} – ${fmt(end)}`
}
